import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, TimeoutError, catchError, timeout } from 'rxjs';
import { ToastService } from 'asksuite-citrus';
import { LocalizationService } from '../services/localization.service';

const DEFAULT_TIMEOUT = 30000;
export const CUSTOM_TIMEOUT_HEADER = 'X-Custom-Timeout';

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
  constructor(
    private toast: ToastService,
    private localize: LocalizationService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const customTimeout = Number(request.headers.get(CUSTOM_TIMEOUT_HEADER));
    const timeoutMs = customTimeout > 0 ? customTimeout : DEFAULT_TIMEOUT;

    const cleanReq = request.headers.has(CUSTOM_TIMEOUT_HEADER)
      ? request.clone({ headers: request.headers.delete(CUSTOM_TIMEOUT_HEADER) })
      : request;

    return next.handle(cleanReq).pipe(
      timeout(timeoutMs),
      catchError((error) => {
        if (error instanceof TimeoutError) {
          this.toast.danger(this.localize.key('REQUEST_TIMEOUT'));
        }

        throw error;
      })
    );
  }
}
